export default __webpack_public_path__ + "static/media/bg-collab-details.9e87bc47.jpg";